import { useState, useEffect } from 'react';
import { collection, query, where, limit, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

let cachedHasCondominiums = null;
let inflightPromise = null;

async function fetchHasPublicCondominiums() {
  if (cachedHasCondominiums !== null) return cachedHasCondominiums;
  if (inflightPromise) return inflightPromise;

  inflightPromise = (async () => {
    try {
      const publicQuery = query(
        collection(db, 'condominiums'),
        where('isAvailable', '==', true),
        where('isInactive', '==', false),
        limit(1)
      );
      const snap = await getDocs(publicQuery);
      cachedHasCondominiums = !snap.empty;
      return cachedHasCondominiums;
    } catch {
      cachedHasCondominiums = false;
      return false;
    } finally {
      inflightPromise = null;
    }
  })();

  return inflightPromise;
}

/** True quando existe ao menos um condomínio público (disponível e ativo). */
export function useHasPublicCondominiums() {
  const [hasCondominiums, setHasCondominiums] = useState(
    () => cachedHasCondominiums === true
  );

  useEffect(() => {
    let cancelled = false;
    fetchHasPublicCondominiums().then((has) => {
      if (!cancelled) setHasCondominiums(has);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return hasCondominiums;
}
